export const INITIAL_WORDS = []
export const DEMO_WORDS = [
  { name: "inane", issues: 0 },
  { name: "trifling", issues: 0 },
  { name: "incite", issues: 0 },
  { name: "implied", issues: 0 },
  { name: "retard", issues: 0 },
  { name: "indignantly", issues: 0 },
  { name: "trivial", issues: 0 },
  { name: "emerge", issues: 0 },
  { name: "arrogant", issues: 0 },
  { name: "prickly", issues: 0 },
  { name: "abreast", issues: 0 },
  { name: "pique", issues: 0 },
]

export const INITIAL_TOPICS = []

export const DEMO_TOPICS = [
  "technology",
  "innovation",
  "startups",
  "AI",
  "big tech",
  "data",
  "artificial intelligence",
  "data monetization",
  "data science",
  "machien learning",
  "data analytics",
  "IoT"
];

export const INITIAL_ARTICLES = [
  {
    title: "Your News & Vocabulary Companion - LexiNews",
    keywords: [],
    url: null,
    publishedAt: null,
    source: null,
    content:
      "Elevating your vocabulary while remaining abreast of current events? That's LexiNews. It seamlessly integrates news browsing with vocabulary enhancement, offering you an efficient approach to intellectual growth. Encounter an unfamiliar word? Simply tap on it to check its definition. But wait, there's more! We'll rewrite the next articles to include this word for you to practice until you master it. Say hello to a more refined and enlightened you. Click \"Next\" button above to see further instructions.",
  },
  {
    title: "Getting started",
    keywords: [],
    url: null,
    publishedAt: null,
    source: null,
    content:
      "Welcome to your personalized news and vocabulary enrichment journey! Below, you'll find a selection of topics to explore. Feel free to delete the ones you're not interested in and add any additional topics that pique your curiosity. Once you're satisfied with your selections, click \"Get articles for your interests\" to dive into a curated collection of news articles from various sources. Browse the short summaries, and if one catches your eye, click \"GET FULL ARTICLE\" to access the entire piece. Initially, you'll see the original text, but with a simple click of \"Inject\" magic will happen. Read through the article and click on any words you're unfamiliar with to enhance your vocabulary effortlessly. Happy exploring!"
  },
]

export const DEMO_REWRITTEN_ARTICLE = {
  "adapted_article": "<mark>On</mark> March 17th, 2025</b>,  `Inline code` Proficio ==Capital Partners== LLC made a <span style=\"background-color: #FFFF00\">staggering</span> acquisition by <span class=\"highlight\">highlighted text</span> a stake in Kforce Inc. (NASDAQ:KFRC – Free Report) during the 4th quarter, according to their latest SEC filing. This institutional investor ardently purchased 87,318 shares of the business services provider, an investment valued at approximately $4,951,000, representing 0.46% ownership of Kforce as per the recent disclosure.  \nSeveral other institutional investors and hedge funds have also bolstered their positions in the firm. TD Private Client Wealth LLC fiercely increased its holdings by 58.0% in the third quarter. It now owns 496 shares, valued at $30,000, following the acquisition of an additional 182 shares. Similarly, Blue Trust Inc. lifted its stake by 17.9% in the fourth quarter, now holding 1,810 shares worth $111,000 after purchasing 275 additional shares. Furthermore, Advisors Asset Management Inc. experienced a remarkable 197.3% increase in its Kforce shares during the third quarter, culminating in ownership of 2,396 shares valued at $147,000, after acquiring 1,590 additional shares. Paloma Partners Management Co and QRG Capital Management Inc. also established new stakes in Kforce, worth $221,000 and $206,000 respectively. Collectively, institutional investors and hedge funds command 92.77% of Kforce’s stock.  \nOn Monday, KFRC stock commenced trading at $50.79, showcasing a quick ratio of 2.06 and a debt-to-equity ratio of 0.16. The company's fifty-day moving average stands at $52.68, while the 200-day average is $56.93. Recently, Kforce announced a dividend increase, with shareholders on record as of March 7th set to receive $0.39 per share, up from the previous $0.38. This initiative exemplifies Kforce’s endeavor to alleviate shareholder concerns amid fluctuating market conditions.  \nAdditionally, StockNews.com scoffed at earlier ratings by upgrading Kforce from \"hold\" to \"buy'' in a report dated November 30th.",
  "used_words": [
      {
          "original_word": "flubbergusted",
          "derived_words_used_in_adapted_article": []
      },
      {
          "original_word": "fierce",
          "derived_words_used_in_adapted_article": [
              "fiercely"
          ]
      },
      {
          "original_word": "exemplify",
          "derived_words_used_in_adapted_article": [
              "exemplifies"
          ]
      },
      {
          "original_word": "alleviate",
          "derived_words_used_in_adapted_article": [
              "alleviate"
          ]
      },
      {
          "original_word": "scoff",
          "derived_words_used_in_adapted_article": [
              "scoffed"
          ]
      },
      {
          "original_word": "endeavors",
          "derived_words_used_in_adapted_article": [
              "endeavor"
          ]
      },
      {
          "original_word": "looms",
          "derived_words_used_in_adapted_article": []
      },
      {
          "original_word": "backdrop",
          "derived_words_used_in_adapted_article": []
      },
      {
          "original_word": "disdain",
          "derived_words_used_in_adapted_article": []
      },
      {
          "original_word": "stagerred",
          "derived_words_used_in_adapted_article": [
              "staggering"
          ]
      },
      {
          "original_word": "ardently",
          "derived_words_used_in_adapted_article": [
              "ardently"
          ]
      },
      {
          "original_word": "untainted",
          "derived_words_used_in_adapted_article": []
      },
      {
          "original_word": "scoffed",
          "derived_words_used_in_adapted_article": []
      },
      {
          "original_word": "acumen",
          "derived_words_used_in_adapted_article": []
      },
      {
          "original_word": "dampen",
          "derived_words_used_in_adapted_article": []
      },
      {
          "original_word": "scoundrels",
          "derived_words_used_in_adapted_article": []
      },
      {
          "original_word": "fervent",
          "derived_words_used_in_adapted_article": []
      },
      {
          "original_word": "paramount",
          "derived_words_used_in_adapted_article": []
      },
      {
          "original_word": "longing",
          "derived_words_used_in_adapted_article": []
      },
      {
          "original_word": "bolstered",
          "derived_words_used_in_adapted_article": [
              "bolstered"
          ]
      }
  ]
}